import {
  TextV2 as Text,
  Avatar,
  Box,
  Flex,
  TextModifier,
} from '@pinchenterprisesnpm/friday-ui'
import { IUserListItemProps } from './user-list-item.types'
import { UserListItemWrapper } from './user-list-item.styles'

export const UserListItem = ({ user }: IUserListItemProps) => (
  <UserListItemWrapper p="sm">
    <Flex alignItems="center">
      <Avatar src={user.avatar_thumb_url} size="small" />
      <Box ml="sm">
        <Text fontWeight="bold">{user.full_name}</Text>
        <Flex mt="xs">
          <Text fontSize="medium">
            Hours worked in the last 30 days:
            <TextModifier fontWeight="bold">
              {' '}
              {user.finished_punch_cards_thirty_trailing_days_sum_hours_total}
            </TextModifier>
            {' | '}
            Last active:{' '}
            <TextModifier fontWeight="bold">
              {user.last_completed_punch_card?.created_at}
            </TextModifier>
          </Text>
        </Flex>
      </Box>
    </Flex>
  </UserListItemWrapper>
)
